import { z } from "zod";

export const baseListingPageFormSchema = z.object({
    searchText: z.string().optional(),
    merchantId: z.array(z.number()).optional(),
});

export type BaseListingPageValuesType = z.infer<typeof baseListingPageFormSchema>;

export const baseListingPageInitialValues: BaseListingPageValuesType = {
    searchText: "",
    merchantId: [],
};
